import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Box,
  Drawer,
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Toolbar,
  Typography,
} from '@mui/material';
import { ExitToApp } from '@mui/icons-material';
import BarChartIcon from '@mui/icons-material/BarChart';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import GroupsIcon from '@mui/icons-material/Groups';
import SportsScoreIcon from '@mui/icons-material/SportsScore';
import RefreshIcon from '@mui/icons-material/Refresh';
import LogOut from './LogOut';
import { fetchGrandPrixList, fetchRoster } from '../utils/ApiHelper';
import { useAuth } from '../auth/AuthContext';
import { GAMEPLAY_SESSION_STORAGE_KEY } from '../utils/GameplayDraft';

const NavDrawer = ({ open, onClose }) => {
  const navigate = useNavigate();
  const { accessToken, logout } = useAuth();
  const [signOut, setLogOut] = useState(false);
  const token = accessToken;
  const user = localStorage.getItem('user') || 'Guest';

  const handleClose = () => {
    onClose();
  };

  const handleLogOut = () => {
    setLogOut(true);
  };

  const handleLogOutConfirm = async () => {
    await logout();
    localStorage.removeItem(GAMEPLAY_SESSION_STORAGE_KEY);
    handleClose();
    navigate('/auth');
    setLogOut(false);
  };

  const handleLogin = () => {
    navigate('/auth');  // Navigate to the login page
    handleClose();
  };

  const handleRosterRefresh = async () => {
    try {
      const roster = await fetchRoster(token); // Wait for fetch to complete
      localStorage.setItem("apiRosterV2", JSON.stringify(roster));
      console.log("Roster Refreshed!");
      window.location.reload();
    } catch (rosterError) {
      console.log("Roster fetch error", rosterError);
    }
  };

  const handleGrandPrixRefresh = async () => {
    try {
      const grandPrixList = await fetchGrandPrixList(token); // Wait for fetch to complete
      localStorage.setItem("apiGrandPrixListV2", JSON.stringify(grandPrixList));
      console.log("Grand Prix List Refreshed!");
      window.location.reload();
    } catch (grandPrixError) {
      console.log("Grand Prix List fetch error", grandPrixError);
    }
  };


  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClose}
    >
      <LogOut
        open={signOut}
        onClose={() => setLogOut(false)}
        onConfirm={handleLogOutConfirm}
      />
      <Box sx={{ width: 250, display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Box sx={{ flex: 1 }}>
          <AppBar position="static" sx={{ backgroundColor: 'primary.dark' }}>
            <Toolbar>
              <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                {user}
              </Typography>
            </Toolbar>
          </AppBar>
          <List>
            {/* Render only if token exists */}
            <ListItemButton href='/stats'>
              <ListItemIcon>
                <BarChartIcon />
              </ListItemIcon>
              <ListItemText primary="Stats" />
            </ListItemButton>
            {token && (
              <>
                <ListItemButton href='/grandprix'>
                  <ListItemIcon>
                    <SportsScoreIcon />
                  </ListItemIcon>
                  <ListItemText primary="Grand Prix" />
                </ListItemButton>
                <ListItemButton href='/raceentry'>
                  <ListItemIcon>
                    <DirectionsCarIcon />
                  </ListItemIcon>
                  <ListItemText primary="Race Entry" />
                </ListItemButton>
                <ListItemButton href='/roster'>
                  <ListItemIcon>
                    <GroupsIcon />
                  </ListItemIcon>
                  <ListItemText primary="Roster" />
                </ListItemButton>

              </>
            )}
          </List>
        </Box>
        <Box sx={{ mb: 5, display: "flex", flexWrap: "wrap", gap: 1 }}>
          <List sx={{ display: "flex", flexWrap: "wrap", padding: 0 }}>
            <ListItemButton sx={{ flex: "1 1 auto", minWidth: 120 }} onClick={handleGrandPrixRefresh}>
              <ListItemIcon>
                <SportsScoreIcon />
                <RefreshIcon />
              </ListItemIcon>
              <ListItemText primary="Refresh GP List" />
            </ListItemButton>
            <ListItemButton sx={{ flex: "1 1 auto", minWidth: 120 }} onClick={handleRosterRefresh}>
              <ListItemIcon>
                <GroupsIcon />
                <RefreshIcon />
              </ListItemIcon>
              <ListItemText primary="Refresh Roster" />
            </ListItemButton>
          </List>
        </Box>
        <Box>
          <List>
            {token ? (
              <ListItemButton onClick={handleLogOut}>
                <ListItemIcon>
                  <ExitToApp /> {/* Icon for Log Out */}
                </ListItemIcon>
                <ListItemText primary="Log Out" />
              </ListItemButton>
            ) : (
              <ListItemButton onClick={handleLogin}>
                <ListItemIcon>
                  <ExitToApp /> {/* Icon for Log In */}
                </ListItemIcon>
                <ListItemText primary="Log In" />
              </ListItemButton>
            )}
          </List>
        </Box>
      </Box>
    </Drawer>
  );
};

export default NavDrawer;
